import React, { useEffect, useState } from "react";
import "./drawer.scss";
import { Button, Col, Input, Row, Select } from "antd";
import { FilterSelect } from "../filterSelect/filterSelect";
import Moment from "jalali-moment";
import { GetReportFilterReq } from "../../interfaces/event.interface";
import { DatePicker as DatePickerJalali } from "antd-jalali";
import dayjs from "dayjs";
import { useParams, useSearchParams } from "react-router-dom";

interface Props {
  value: any;
  onChange: (e: any) => void;
}

const Filters: React.FC<Props> = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [filters, setFilters] = useState({
    start_date: Moment().add(-1, "day").format("YYYY-MM-DD"),
    end_date: Moment().format("YYYY-MM-DD"),
    event_type: "",
  } as GetReportFilterReq);

  useEffect(() => {
    setFilters(props.value);
  }, []);

  return (
    <div className="container">
      <div className="filter-row">
        <div className="filter w-half">
          <p className="title">بازه زمانی :</p>
          <DatePickerJalali.RangePicker
            size="large"
            variant={"filled"}
            onChange={(e: any) => {
              const startDate = Moment(e[0]["$d"]).format("YYYY-MM-DD");
              const endDate = Moment(e[1]["$d"]).format("YYYY-MM-DD");
              setFilters({
                ...filters,
                start_date: startDate,
                end_date: endDate,
              });
            }}
            value={[dayjs(filters.start_date), dayjs(filters.end_date)]}
          />
        </div>
        <div className="filter w-half">
          <p className="title">نوع رویداد :</p>
          <FilterSelect
            value={filters.event_type}
            fieldName="event_type"
            onChange={(e) => {
              setFilters({
                ...filters,
                event_type: e,
              });
            }}
          />
        </div>
      </div>

      <div className="filter-row">
        <div className="filter w-half">
          <p className="title">شرکت سازنده :</p>
          <FilterSelect
            value={filters.device_manufacturer}
            fieldName="device_manufacturer"
            onChange={(e) => {
              setFilters({
                ...filters,
                device_manufacturer: e,
              });
            }}
          />
        </div>
        <div className="filter w-half">
          <p className="title">مدل دستگاه :</p>
          <FilterSelect
            value={filters.device_model}
            fieldName="device_model"
            onChange={(e) => {
              setFilters({
                ...filters,
                device_model: e,
              });
            }}
          />
        </div>
      </div>

      <div className="filter-row">
        <div className="filter w-half">
          <p className="title">نام پکیج :</p>
          <FilterSelect
            value={filters.package_name}
            fieldName="package_name"
            onChange={(e) => {
              setFilters({
                ...filters,
                package_name: e,
              });
            }}
          />
        </div>
        <div className="filter w-half">
          <p className="title">معماری پردازنده :</p>
          <Select
            size="large"
            variant="filled"
            value={
              filters.support_64_bit ? 64 : filters.support_32_bit ? 32 : ""
            }
            onChange={(e: any) => {
              let is32 = false;
              let is64 = false;
              if (e == 32) {
                is32 = true;
              }
              if (e == 64) {
                is64 = true;
              }
              setFilters({
                ...filters,
                support_64_bit: is64,
                support_32_bit: is32,
              });
            }}
            options={[
              {
                value: 32,
                label: "۳۲ بیتی",
              },
              {
                value: 64,
                label: "۶۴ بیتی",
              },
            ]}
          />
        </div>
      </div>

      <div className="filter-row">
        <div className="filter w-half">
          <p className="title">ورژن اپلیکیشن :</p>
          <FilterSelect
            value={filters.app_version}
            fieldName="app_version"
            onChange={(e) => {
              setFilters({
                ...filters,
                app_version: e,
              });
            }}
          />
        </div>
        <div className="filter w-half">
          <p className="title">ورژن اندروید :</p>
          <FilterSelect
            value={filters.android_version}
            fieldName="android_version"
            onChange={(e) => {
              setFilters({
                ...filters,
                android_version: e,
              });
            }}
          />
        </div>
      </div>

      <div className="filter-row">
        <div className="filter w-half">
          <p className="title">کشور :</p>
          <FilterSelect
            value={filters.request_ip_country_name}
            fieldName="request_ip_country_name"
            onChange={(e) => {
              setFilters({
                ...filters,
                request_ip_country_name: e,
              });
            }}
          />
        </div>
        <div className="filter w-half">
          <p className="title">موارد غیر متعارف :</p>
          <Select
            size="large"
            variant="filled"
            value={
              filters.anomaly_date
            }
            onChange={(e: any) => {
              setFilters({
                ...filters,
                anomaly_date: e,
              });
            }}
            options={[
              {
                value: true,
                label: "شامل موارد غیر متعارف باشد",
              },
              {
                value: false,
                label: "شامل موارد غیر متعارف نباشد",
              },
            ]}
          />
        </div>
      </div>

      <div className="filter-row">
        <div className="filter w-half">
          <p className="title">میزان ریسک</p>
          <Input
            type="number"
            variant="filled"
            size="large"
            value={filters.event_risk}
            onChange={(e) => {
              setFilters({
                ...filters,
                event_risk: parseInt(e.target.value),
              });
            }}
          />
        </div>
        <div className="filter w-half">
          <p className="title">آدرس IP :</p>
          <Input
            variant="filled"
            size="large"
            value={filters.request_ip}
            onChange={(e) => {
              setFilters({
                ...filters,
                request_ip: e.target.value,
              });
            }}
          />
        </div>
      </div>

      <Row justify={"space-between"} align={"middle"} gutter={10}>
        <Col md={20} xs={24}>
          <Button
            block
            type="primary"
            size="large"
            style={{ padding: 22, boxShadow: "none", marginTop: 10 }}
            onClick={() => {
              let temp = {} as any;
              const f = { ...filters } as any;
              Object.keys(filters).map((i) => {
                if (f[i]) {
                  temp[i] = f[i];
                }
              });
              setSearchParams(temp);
              props.onChange(filters);
            }}
          >
            اعمال
          </Button>
        </Col>
        <Col md={4} xs={24}>
          <Button
            block
            type="primary"
            size="large"
            variant="solid"
            color="orange"
            style={{ padding: 22, boxShadow: "none", marginTop: 10 }}
            onClick={() => {
              setFilters({
                start_date: Moment().add(-1, "day").format("YYYY-MM-DD"),
                end_date: Moment().format("YYYY-MM-DD"),
                event_type: "",
              } as GetReportFilterReq);
            }}
          >
            پاک کردن
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Filters;
